/**
 * @description Gestion de la navigation clavier des suggestions de recherches
 */

/* global bsBreakpoints */

(() => {
	// Const menu
	const header = document.querySelector('[data-js-header]');
	const headerMenu = document.querySelector('[data-js-header-nav]') || null;
	const headerMenuRWD = document.querySelector('[data-js-header-menu-rwd]');
	const headerMenuToggle = document.querySelector(
		'[data-js-header-menu-toggle]'
	);
	const headerMenuPrevious = document.querySelectorAll(
		'[data-js-header-menu-previous]'
	);

	if (headerMenu) {
		const leafs = headerMenu.querySelectorAll('.leaf') || null;
		if (leafs) {
			leafs.forEach((leaf) => {
				let expanded;

				if (!leaf.querySelector(':scope > a')) {
					leaf.querySelector(':scope > span').tabIndex = '0';
				}

				leaf.classList.contains('expanded')
					? (expanded = true)
					: (expanded = false);
				if (expanded) {
					leaf.querySelector('a, span[tabindex="0"]').setAttribute(
						'aria-haspopup',
						'true'
					);

					leaf.addEventListener('mouseover', (e) => {
						const submenu =
							e.target.parentNode.querySelector(
								'.header__menu__submenu-lvl-2'
							) || null;
						document.addEventListener('keydown', (e) => {
							if (e.key === 'Escape' && submenu) {
								submenu.classList.add('submenu-a11Y');
							}
						});
					});
					leaf.addEventListener('mouseout', (e) => {
						const submenu =
							e.target.parentNode.querySelector(
								'.header__menu__submenu-lvl-2'
							) || null;

						if (
							submenu &&
							submenu.classList.contains('submenu-a11Y')
						) {
							document
								.querySelectorAll(
									'.header__menu__submenu-lvl-2'
								)
								.forEach((el) => {
									el.classList.remove('submenu-a11Y');
								});
						}
					});
				}
			});
		}
	}

	const navMenu = (active, child, e) => {
		const left = e.key === 'ArrowLeft';
		const down = e.key === 'ArrowDown';
		const back = e.key === 'Backspace';
		const tab = e.key === 'Tab';
		const right = e.key === 'ArrowRight';
		const escape = e.key === 'Escape';
		const shiftTab = e.shiftKey && e.keyCode === 9;

		const next = active.nextElementSibling;
		const prev = active.previousElementSibling;
		const activeLeaf = headerMenu.querySelector('.leaf-lvl-1.active');

		if (left || shiftTab) {
			// flèche gauche, retour arrière, shiftap, revenir à l'élément précedant restant sur le niveau actuel
			if (!active.classList.contains('first')) {
				prev.querySelector('a, span[tabindex="0"]').focus();
				e.preventDefault();
			}
		} else {
			// flèche droite et tab, rester sur le niveau actuel
			if (right || tab) {
				if (next) {
					next.querySelector('a, span[tabindex="0"]').focus();
					e.preventDefault();
				} else {
					if (
						active.parentNode.parentNode.classList.contains('last')
					) {
						document.activeElement.blur();
						activeLeaf.classList.remove('active');
						const submenu = activeLeaf.querySelector('.active');
						if (submenu) {
							submenu.classList.remove('active');
						}
					} else {
						if (!active.classList.contains('leaf-lvl-1')) {
							active.parentNode.parentNode.nextElementSibling.firstElementChild.focus();
							e.preventDefault();
						}
					}
				}

				// utilisation de la flèche du bas pour aller dans les sous niveau, sinon on reste sur le niveau actuel
			} else if (down) {
				if (child) {
					if (active.classList.contains('leaf-lvl-1')) {
						active.classList.add('active');
					}
					child.querySelector('a, span[tabindex="0"]').focus();
				}
				e.preventDefault();
			} else if (escape) {
				const lvl1 =
					headerMenu.querySelector(
						'.leaf-lvl-1.active > a, .leaf-lvl-1.active > span[tabindex="0"]'
					) || null;
				if (lvl1) {
					lvl1.focus();
				}
			} else if (back) {
				if (
					active.classList.contains('leaf-lvl-1') &&
					!active.classList.contains('first')
				) {
					active.previousElementSibling
						.querySelector('a, span[tabindex="0"]')
						.focus();
				} else {
					active
						.closest('.leaf-lvl-1')
						.querySelector('a, span[tabindex="0"]')
						.focus();
				}
			}
		}
	};

	const keyBoardNav = (e) => {
		const active = document.activeElement.parentNode;

		if (active.classList.contains(`leaf`)) {
			let child;

			if (active.classList.contains(`leaf-lvl-1`)) {
				child = active.querySelector('.leaf-lvl-2:nth-child(2)');
			} else if (active.classList.contains(`leaf-lvl-2`)) {
				child = active.querySelector('.leaf-lvl-3:nth-child(2)');
			} else if (active.classList.contains(`leaf-lvl-3`)) {
				child = active.nextElementSibling;
			}
			navMenu(active, child, e);

			// remove class active on leaf lvl 1 if focus another lvl-1
			setTimeout(function () {
				if (
					document.activeElement.parentElement.classList.contains(
						'leaf-lvl-1'
					)
				) {
					const leafActive =
						headerMenu.querySelector('.leaf-lvl-1.active') || null;

					if (leafActive) {
						leafActive.classList.remove('active');
					}
				}
			}, 0);

			// Gestion du sous menu version 1 (lvl-2)
			SubMenuV1Desktop();
		}
	};

	// Sélection fonction de navigation du menu selon device
	const navDevice = () => {
		// remove listenner keydown (évite les bugs de répétition)
		headerMenu.removeEventListener('keydown', keyBoardNav);
		if (
			bsBreakpoints.detectBreakpoint() === 'xLarge' ||
			bsBreakpoints.detectBreakpoint() === 'large'
		) {
			headerMenu.addEventListener('keydown', keyBoardNav);
		} else {
			previous();
			headerMenu.addEventListener('keydown', keyBoardNavMobile);
		}
	};

	// Gestion de la nav clavier en mobile / tablette
	const keyBoardNavMobile = (e) => {
		const parent = document.activeElement.parentNode;
		const lastLink =
			parent.classList.contains('last') &&
			!parent.classList.contains('expanded');
		const lastBtn =
			parent === headerMenu.lastElementChild &&
			document.activeElement.tagName === 'BUTTON';
		if ((lastLink || lastBtn || e.key === 'Escape') && e.key !== 'Enter') {
			e.preventDefault();
			headerMenuToggle.focus();
		}

		aftetToggle();
	};

	const aftetToggle = () => {
		// Gestion au click sur le bouton toggle
		headerMenuToggle.addEventListener('keydown', (e) => {
			if (headerMenuToggle.classList.contains('active')) {
				if (e.key === 'ArrowDown' || e.key === 'Tab') {
					e.preventDefault();
					const submenus =
						header.querySelectorAll(
							'.header__menu__submenu.active'
						) || null;
					if (submenus.length > 0) {
						submenus[submenus.length - 1]
							.querySelector('button.header__menu__previous')
							.focus();
					} else {
						headerMenuRWD
							.querySelector(
								'.leaf-lvl-1.first a, .leaf-lvl-1.first span[tabindex="0"]'
							)
							.focus();
					}
				}
			}
		});
	};

	const previous = () => {
		headerMenuPrevious.forEach(function (prev) {
			const parent = prev.closest('.header__menu__submenu');
			prev.addEventListener('click', function () {
				// Remove le sous-menu actif
				parent.classList.remove('active');

				const goNext = headerMenu.querySelectorAll(
					'[aria-expanded="true"]'
				);

				if (goNext.length > 0) {
					goNext[goNext.length - 1].setAttribute(
						'aria-expanded',
						false
					);
				}

				const submenus =
					header.querySelectorAll('.header__menu__submenu.active') ||
					null;
				if (submenus.length > 0) {
					submenus[submenus.length - 1]
						.querySelector('button.header__menu__previous')
						.focus();
				} else {
					headerMenuRWD
						.querySelector(
							'.leaf-lvl-1.first a, .leaf-lvl-1.first span[tabindex="0"]'
						)
						.focus();
				}
			});
		});
	};

	// Gestion de la class active sur les items de menu lvl-2 sur la version 1 du sous menu
	const SubMenuV1Desktop = () => {
		const lvl2 = headerMenu.querySelectorAll('.leaf-lvl-2 > a');
		lvl2.forEach((leaf) => {
			leaf.addEventListener('focus', () => {
				const active =
					headerMenu.querySelector('.leaf-lvl-2.active') || null;
				if (active) {
					active.classList.remove('active');
				}
				leaf.parentNode.classList.add('active');
			});
		});
	};

	// Go after load
	window.addEventListener('load', function () {
		if (document.body.contains(header)) {
			navDevice();
		}
		let resizeTime;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTime);
			resizeTime = setTimeout(doneResizing, 500);
		});

		const doneResizing = () => {
			// désactiver un sous-menu actif au resize, préviens des bugs visuels en passant de mobile a desktop
			header.querySelectorAll('.active').forEach((active) => {
				active.classList.remove('active');
			});
			navDevice();
		};
	});
})();
